import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import artistComponent from './artist.component';

const artistModule = angular
  .module('artist', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.artist', {
      url: '/artists/{artistSlug:[0-9a-zA-Z_-]{1,200}}?discipline',
      resolve: {
        artist: ($stateParams, ApiService, InstagramService) =>
          ApiService.entitySearchOne({
            q: `schema:artist AND slug:"${$stateParams.artistSlug}"`,
            children: [
              'assets, folios',
              // 'heroAssets[*]:group(2):sample, assets[*]:group(2):slice(0,2)',
              'folios, heroAssets, assets[*]:group(2):slice(0,2)',
              'heroAssets, assets[*]:group(2):slice(0,2)',
            ],
          }).then((artist) => {
            if (
              !artist.fields.instagramEnabled ||
              !artist.fields.instagramUserName
            ) {
              return artist;
            }
            return InstagramService.userMedia(
              artist.fields.instagramUserName
            ).then((media) => {
              artist.instagramMedia = media;
              return artist;
            });
          }),
      },
      views: {
        content: {
          component: 'artist',
        },
      },
    });
  })

  .service('InstagramService', ($http, $q) => {
    'ngInject';

    return {
      userMedia(userName) {
        return $q((resolve) => {
          $http.get(`/instagram/${userName}/media`).then(
            (response) => {
              resolve(response.data);
            },
            () => {
              resolve([]);
            }
          );
        });
      },
    };
  })

  .component('artist', artistComponent);

export default artistModule;
